import { Link } from "react-router-dom";

const Navbar = () => {
    return (
        <nav className="top-5 left-0 w-full z-50 backdrop-blur-md px-4 pt-4 pb-2 border-b border-[#fafbff]/10" >
            < div className="flex justify-between" >
                {/* The left side */}
                <div>
                    <Link to="/"><p className="text-gray-500">sahir_p</p></Link>
                </div>

                {/* The right side */}
                <div className="flex justify-between gap-4 md:gap-8" >
                    <Link to="/projects">
                        <p className="text-gray-500">my work</p>
                    </Link>
                    <Link to="/about">
                        <p className="text-gray-500">about me</p>
                    </Link>
                    <Link to="mailto:info@sahirprajapati.com">
                        <p className="text-gray-500">let's make something</p>
                    </Link>
                </div >
            </div >
        </nav >
    )
}

export default Navbar;